export default "__VITE_ASSET__B4Ueof6s__"